<template>
    <proposal-iframe 
        :padding="true"
        overflow="hidden"
        ref="section_iframe" 
        style="width: 100%; overflow: hidden; border: 0" 
        :style="iframeStyles"
        @loaded="resizeIframe"
    >
        <proposal-our-goals 
            v-if="section === 'our_goals'"
            :proposal_document="form_data.proposal_document"
            :section="form_data.proposal_document.sections.our_goals"
        />
        <proposal-job-board
            v-else-if="section === 'job_board'"
            :proposal_document="form_data.proposal_document"
            :section="form_data.proposal_document.sections.job_board"
        />
        <proposal-hiring-area
            v-else-if="section === 'hiring_area'"
            :proposal_document="form_data.proposal_document"
            :section="form_data.proposal_document.sections.hiring_area"
        />
        <proposal-hammer-and-job-adviser
            v-else-if="section === 'hammer_and_job_adviser'"
            :proposal_document="form_data.proposal_document"
            :section="form_data.proposal_document.sections.hammer_and_job_adviser"
        />
        <proposal-mc-leads
            v-else-if="section === 'mc_leads'"
            :proposal_document="form_data.proposal_document"
            :section="form_data.proposal_document.sections.mc_leads"
        />
        <proposal-video-advertising
            v-else-if="section === 'video_advertising'"
            :proposal_document="form_data.proposal_document"
            :section="form_data.proposal_document.sections.video_advertising"
        />
        <proposal-brand-and-reputation
            v-else-if="section === 'brand_and_reputation'"
            :proposal_document="form_data.proposal_document"
            :section="form_data.proposal_document.sections.brand_and_reputation"
        />
        <proposal-new-hire-guarantee
            v-else-if="section === 'new_hire_guarantee'"
            :proposal_document="form_data.proposal_document"
            :section="form_data.proposal_document.sections.new_hire_guarantee"
        />

        <proposal-pricing-options
            v-else-if="section === 'pricing_options'"
            :value="defaultSelectedOption"
            :data="form_data"
        />
        <proposal-agreement
            v-else-if="section === 'agreement'"
            :data="form_data"
            :selected-option="defaultSelectedOption"
        />
    </proposal-iframe>
</template>

<script>
import ProposalIframe from './proposal-iframe.vue';
import ProposalOurGoals from "./../../../ProposalsPresentation3/vue/parts/proposal-20-our-goals";
import ProposalJobBoard from "./../../../ProposalsPresentation3/vue/parts/proposal-21-job-board";
import ProposalHiringArea from "./../../../ProposalsPresentation3/vue/parts/proposal-22-hiring-area";
import ProposalHammerAndJobAdviser from "./../../../ProposalsPresentation3/vue/parts/proposal-23-hammer-and-job-adviser";
import ProposalMcLeads from "./../../../ProposalsPresentation3/vue/parts/proposal-24-mc-leads";
import ProposalVideoAdvertising from "./../../../ProposalsPresentation3/vue/parts/proposal-25-video-advertising";
import ProposalBrandAndReputation from "./../../../ProposalsPresentation3/vue/parts/proposal-26-brand-and-reputation";
import ProposalNewHireGuarantee from "./../../../ProposalsPresentation3/vue/parts/proposal-27-new-hire-guarantee";
import ProposalPricingOptions from "./../../../ProposalsPresentation3/vue/parts/proposal-30-pricing-options";
import ProposalAgreement from "./../../../ProposalsPresentation3/vue/parts/proposal-40-agreement";

export default {
    components: {
        ProposalIframe,
        ProposalOurGoals,
        ProposalJobBoard,
        ProposalHiringArea,
        ProposalHammerAndJobAdviser,
        ProposalMcLeads,
        ProposalVideoAdvertising,
        ProposalBrandAndReputation,
        ProposalNewHireGuarantee,
        ProposalPricingOptions,
        ProposalAgreement,
    },
    props: [
        'form_data',
        'section',
    ],
    data() {
        return {
            iframeHeight: "100%",
        };
    },
    computed: {
        // Preselect the "recommended" plan (Pro / option 2) when it is active; otherwise the first active plan.
        defaultSelectedOption() {
            const isActive = (n) => this.form_data['pricing_option' + n] && this.form_data['pricing_option' + n].is_active;

            if (isActive(2)) {
                return 2;
            }

            return [1, 2, 3, 4].find(isActive) || 1;
        },
        sectionData() {
            return this.form_data.proposal_document.sections[this.section];
        },
        iframeStyles() {
            return {
                height: this.iframeHeight,
            }
        },
    },
    watch: {
        sectionData: {
            deep: true,
            handler() {
                this.$nextTick(() => {
                    this.resizeIframe();
                });
            }
        }
    },
    methods: {
        resizeIframe() {
            const iframeWindow = this.$refs.section_iframe.$el.contentWindow;
            const imgs = iframeWindow.document.querySelectorAll("img");

            imgs.forEach((img) => {
                // if image is not loaded yet, resize iframe after it is loaded
                if(! img.complete) {
                    img.addEventListener('load', () => {
                        this.$nextTick(() => {
                            this.setIframeHeight();
                        });
                    });
                }
            });

            this.setIframeHeight();
        },
        setIframeHeight() {
            if(! this.$refs.section_iframe) {
                return;
            }

            const iframeWindow = this.$refs.section_iframe.$el.contentWindow;

            const divEl = iframeWindow.document.querySelector('body div');
            if(divEl) {
                let newHeight = divEl.offsetHeight + 64;
                this.iframeHeight = newHeight + 'px';
            }
        },
    },
    mounted() {
        window.addEventListener("resize", () => this.setIframeHeight());

        // hacks (pricing options fix)
        setTimeout(() => {
            this.setIframeHeight();
        }, 500);
        setTimeout(() => {
            this.setIframeHeight();
        }, 1500);
    },
    beforeDestroy() {
        window.removeEventListener("resize", () => this.setIframeHeight());
    }
};
</script>
